export default __webpack_public_path__ + "static/media/Click1.47102565.mp3";